/**
 * Validation helper for Calculator
 * Extracted to reduce Calculator.js file size
 */

export function validateCalculatorInputs(scenarioInfo, volumeAssumptions, proposedPricing, transactionDistribution) {
  const errors = [];
  
  console.log('[ValidationHelpers] Validating with readersQty:', scenarioInfo.readersQty, 'Type:', typeof scenarioInfo.readersQty);
  
  // BLOCK 1: Scenario Information
  if (!scenarioInfo.municipality?.trim()) errors.push('Municipality is required');
  if (!scenarioInfo.state?.trim()) errors.push('State is required');
  if (!scenarioInfo.service?.trim()) errors.push('Service/Product is required');
  if (!scenarioInfo.billingFrequency?.trim()) errors.push('Billing Frequency is required');
  if (!scenarioInfo.scenarioName?.trim()) errors.push('Scenario Name is required');
  if (!scenarioInfo.asOfDate?.trim()) errors.push('As-Of Date is required');
  if (!scenarioInfo.accountExecutive?.trim()) errors.push('Account Executive is required');
  if (scenarioInfo.readersQty === null || scenarioInfo.readersQty === undefined || scenarioInfo.readersQty < 0) {
    errors.push('Readers Qty must be 0 or greater');
  }
  // Only require reader type if readers quantity > 0
  if (scenarioInfo.readersQty > 0 && !scenarioInfo.readerType?.trim()) {
    errors.push('Reader Type is required');
  }
  if (!scenarioInfo.partnership?.trim()) errors.push('Partnership (Yes/No) is required');
  if (!scenarioInfo.cardProcessor?.trim()) errors.push('Card Processor is required');
  if (!scenarioInfo.achProcessor?.trim()) errors.push('ACH Processor is required');
  
  // BLOCK 2: Volume Assumptions
  if (!volumeAssumptions.totalPayments || volumeAssumptions.totalPayments <= 0) {
    errors.push('Total Payments must be greater than 0');
  }
  if (!volumeAssumptions.totalTransactions || volumeAssumptions.totalTransactions <= 0) {
    errors.push('Total Transactions must be greater than 0');
  }
  if (volumeAssumptions.achPercent === null || volumeAssumptions.achPercent === undefined) {
    errors.push('ACH % is required');
  }
  if (volumeAssumptions.ccPercent === null || volumeAssumptions.ccPercent === undefined) {
    errors.push('CC % is required');
  }
  if (volumeAssumptions.amexPercent === null || volumeAssumptions.amexPercent === undefined) {
    errors.push('Amex % is required');
  }
  if (volumeAssumptions.debitPercent === null || volumeAssumptions.debitPercent === undefined) {
    errors.push('Debit % is required');
  }
  
  // BLOCK 4: Proposed Pricing
  // Note: Tier max amounts are NOT strictly enforced - they can be 0 or any value
  if (proposedPricing.tier1MinFee === null || proposedPricing.tier1MinFee === undefined) {
    errors.push('Proposed Tier 1 Min Fee is required');
  }
  if (proposedPricing.tier2MinFee === null || proposedPricing.tier2MinFee === undefined) {
    errors.push('Proposed Tier 2 Min Fee is required');
  }
  if (proposedPricing.tier3MinFee === null || proposedPricing.tier3MinFee === undefined) {
    errors.push('Proposed Tier 3 Min Fee is required');
  }
  
  // Payment rates - Allow 0 values as some payment types may not be used
  // Only validate that the field exists, not that it's greater than 0
  if (proposedPricing.paymentRates?.ACH?.takeRate === null || proposedPricing.paymentRates.ACH?.takeRate === undefined) {
    errors.push('Proposed ACH rate is required');
  }
  if (proposedPricing.paymentRates?.CC?.takeRate === null || proposedPricing.paymentRates.CC?.takeRate === undefined) {
    errors.push('Proposed CC rate is required');
  }
  if (proposedPricing.paymentRates?.AMEX?.takeRate === null || proposedPricing.paymentRates.AMEX?.takeRate === undefined) {
    errors.push('Proposed AMEX rate is required');
  }
  if (proposedPricing.paymentRates?.DEBIT?.takeRate === null || proposedPricing.paymentRates.DEBIT?.takeRate === undefined) {
    errors.push('Proposed DEBIT rate is required');
  }
  
  // ACH Flat Fee is optional - defaults to 0 if not provided
  
  // BLOCK 5: Transaction Distribution
  transactionDistribution.forEach((item, idx) => {
    if (!item.collectionAmount?.trim()) {
      errors.push(`Transaction Distribution Row ${idx + 1}: Collection Amount is required`);
    }
    if (item.low === null || item.low === undefined) {
      errors.push(`Transaction Distribution Row ${idx + 1}: Low value is required`);
    }
    if (item.mid === null || item.mid === undefined) {
      errors.push(`Transaction Distribution Row ${idx + 1}: Mid value is required`);
    }
    if (item.high === null || item.high === undefined) {
      errors.push(`Transaction Distribution Row ${idx + 1}: High value is required`);
    }
    if (item.currentPercent === null || item.currentPercent === undefined || item.currentPercent < 0) {
      errors.push(`Transaction Distribution Row ${idx + 1}: Current % is required`);
    }
  });
  
  return errors;
}

export function calculateVolumeTotal(volumeAssumptions) {
  return (
    (parseFloat(volumeAssumptions.achPercent) || 0) +
    (parseFloat(volumeAssumptions.ccPercent) || 0) +
    (parseFloat(volumeAssumptions.amexPercent) || 0) +
    (parseFloat(volumeAssumptions.debitPercent) || 0)
  ).toFixed(2);
}

export function calculateDistributionTotal(transactionDistribution) {
  return transactionDistribution
    .reduce((sum, item) => sum + (parseFloat(item.currentPercent) || 0), 0)
    .toFixed(2);
}
